<script>
import adminTable from './mixins/adminTable'
export default
{
    name: 'site-notifications',

    mixins: [ adminTable ],

    data()
    {
        return {
            url: '/v1/admin/sitenotifications',
            tableName: 'tableSitenotifications',
            data: [],
            emptyModel: { name:null, name_en:null, is_active: 1, icon: null, icon_id: null, link: null, },
            columns: [ 'id', 'name','link', 'is_active', 'created_at', 'actions' ],
            options: {
                headings: {
                    name: 'Cím',
                    link: 'Link',
                    is_active: 'Aktív?',
                    actions: this.$t('TABLE.ACTIONS'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    updated_at: this.$t('GENERAL.UPDATED_AT'),
                },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['name', 'created_at',],
            },
        }
    },
}
</script>

<template>
<div class="container-fluid">
  <mv-modal ref="form">
      <span slot="header">Pop Up</span>
      <mv-site-notification-form :model="model" :edit="formEdit" @save="saveForm"></mv-site-notification-form>
      <div slot="footer">
          <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
          <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
      </div>
  </mv-modal>
  <div class="panel panel-primary">
      <div class="panel-heading">
          <div class="row">
              <div class="col-sm-10">
                  <h4>Pop Up</h4>
              </div>
              <div class="col-sm-2 text-right">
                  <button class="btn btn-xs btn-warning" @click="newModel">
                      <icon name="plus"></icon>
                  </button>
              </div>
          </div>
      </div>
      <div class="panel-body">
          <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
              <div slot="actions" slot-scope="props" class="text-center">
                  <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                      <icon name="remove"></icon>
                  </button>
                  <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                      <icon name="edit"></icon>
                  </button>
              </div>
              <div slot="is_active" slot-scope="props">
                  <div v-if="props.row.is_active" class="text-primary">
                    Igen
                  </div>
                  <div v-else class="text-danger">
                    Nem
                  </div>
              </div>
          </v-client-table>
      </div>
  </div>
</div>
</template>




// WEBPACK FOOTER //
// src/pages/SiteNotifications.vue